import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Typography from '@material-ui/core/Typography';
import { flexbox } from '@material-ui/system';

const useStyles = makeStyles({
  root: {
    maxWidth: 300,
    minWidth: 300,
    marginTop: 12,
  },
  media: {
    height: 140,
  },
  media2: {
    height: 240,
  },
  pos: {
    marginTop: 12,
  },
  grid: {
    display: 'flex',
    width: "100%",
    justifyContent: "space-around"
  },
  column: {
    display: 'flex',
    flexDirection: "column",
    width: "48%",
    alignItems: "space-around"
  }
});


function ProjectCard(props) {
  const classes = useStyles();
  return (
    <a href={props.link} target="_blank">
      <Card className={classes.root} variant="outlined">
        <CardActionArea>
          <CardMedia
            className={classes.media}
            image={props.img}
            title={props.title}
          />
          <CardContent>
            <Typography gutterBottom variant="h5" component="h2">
              {props.header}
            </Typography>
            <Typography variant="body2" color="textPrimary" component="div">
              {props.caption}
              <br /> 
              <h4 className={classes.pos}>Technologies Used:  {props.tech}</h4>
            </Typography>
          </CardContent>
        </CardActionArea>
      </Card>
    </a>
  )
}

export default function Projects() {
  const classes = useStyles();

  return (
    <div className="row">
    <div className="col-12 col-md-6 col-lg-6" style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
      
      <ProjectCard 
        link="https://umakantv.github.io/digitests/" 
        img="https://raw.githubusercontent.com/umakantv/info/gh-pages/images/projects/digitest.jpg" 
        title="Digitest"
        header="Digitest"
        caption="It is a Progressive Web App that lets teachers create tests, host them or download a printable version for hard-copy format. Students can take tests and their results are submitted to testcurator and students via knowledge-rich charts. It has many user-friendly features to allow users to curate tests, such as markdown-support with TeX keyboard. My goal is to create a web app indistinguishable from native apps with powerful features."
        tech="Node.js, MongoDB, Express, React"
      />
      <ProjectCard 
        link="https://shrouded-wildwood-22277.herokuapp.com/" 
        img="https://raw.githubusercontent.com/umakantv/info/gh-pages/images/projects/watchlist.jpg"
        title="Movie Watchlist App"
        header="Movie Watchlist"
        caption="This website allows user to search for movies and add them to their watch list. Also provides a list of popular movies at the time. "
        tech="Node.js, MongoDB, Express"
      />
      
      <ProjectCard 
        link="https://umakantv.github.io/WebDevelopment/Games/MineSweeper/Minesweeper.html" 
        img="https://raw.githubusercontent.com/umakantv/info/gh-pages/images/projects/minesweeper.jpg"
        title="Minsweeper"
        header="Minsweeper"
        caption="Classic Minesweeper with neat UI in browser."
        tech="JavaScript"
      />
      
      <ProjectCard 
        link="https://umakantv.github.io/WebDevelopment/Games/Sudoku/index.html" 
        img="https://raw.githubusercontent.com/umakantv/info/gh-pages/images/projects/sudoku.jpg"
        title="Sudoku"
        header="Sudoku"
        caption="Solve a sudoku. Or just click the solve button."
        tech="JavaScript"
      />
      
      <ProjectCard 
        link="https://umakantv.github.io/WebDevelopment/Games/Doodle/index.html" 
        img="https://raw.githubusercontent.com/umakantv/info/gh-pages/images/projects/draw.jpg"
        title="Draw"
        header="Sketch board"
        caption="Brush it up."
        tech="JavaScript"
      />
      
      <ProjectCard 
        link="https://umakantv.github.io/WebDevelopment/Games/TicTacToe/index.html" 
        img="https://raw.githubusercontent.com/umakantv/info/gh-pages/images/projects/tictactoe.jpg"
        title="TicTacToe"
        header="Tic Tac Toe"
        caption="Classic Tic Tac Toe. Abc of board games."
        tech="JavaScript"
      />

    </div>
    
    <div className="col-12 col-md-6 col-lg-6" style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
      <ProjectCard 
        link="https://uvab.herokuapp.com" 
        img="https://raw.githubusercontent.com/umakantv/info/gh-pages/images/projects/hwcd.jpg" 
        title="Handwriting Dataset Generator"
        header="Handwriting Dataset Generator"
        caption="This project is for curating digital handwriting dataset for hindi and english."
        tech="Node.js, Express, JavaScript, MongoDB"
      />

      <ProjectCard 
        link="https://github.com/umakantv/json_schema" 
        img="https://raw.githubusercontent.com/umakantv/info/gh-pages/images/projects/json.png" 
        title="json-validator"
        header="json-validator"
        caption="It is a light js-based json-data validation module that validates user’s form input in a webpage. You pass json-schema to it and it either gives you a success token or a detailed hierarchal error message."
        tech="JavaScript, Promises"
      />
       <ProjectCard 
        link="https://github.com/umakantv/robot_arm" 
        img="https://camo.githubusercontent.com/1772e15f51f294571afe19e6c63da77b8dc1eb04/68747470733a2f2f692e696d6775722e636f6d2f70496f485368762e6a7067" 
        title="Robot Arm"
        header="Robot Arm Using Arduino Mega"
        caption="It is a simple Robot Arm that reaches to a coordinate input by the user in a 3D space."
        tech="Arduino Mega, L293D Motor Driver, etc."
      />
      <ProjectCard 
       link="https://umakantv.github.io/WebDevelopment/Games/PingPong/index.html" 
       img="https://raw.githubusercontent.com/umakantv/info/gh-pages/images/projects/pingpong.jpg" 
       title="Ping Pong"
       header="Ping Pong"
       caption="Two player Ping Pong with neat user interface."
       tech="JavaScript"
     />
     <ProjectCard 
      link="https://umakantv.github.io/WebDevelopment/Games/Snake&Ladder/game.html" 
      img="https://raw.githubusercontent.com/umakantv/info/gh-pages/images/projects/snakeandladder.jpg" 
      title="Snake & Ladder"
      header="Snake & Ladder"
      caption="Play two player Snake and Ladder with minimalistic abstract UI."
      tech="JavaScript, CSS"
    />

    </div>
    </div>
  );
}
